enum FlightReportStatus{
    submitted = 'Submitted',
    needsAttention = 'Needs attention',
    inProgress = "In progress",
    returned = "Returned", 
    signedOff = "Signed off",
    approved = "Approved", 
    processed = "Processed",
}

export default FlightReportStatus;